import { Text } from '@/components/ui/Text';
import type { DocumentSignatureReturnOutcome } from './document-signature-return-path';

/** Static copy. The page reads no data and never shows the request id. */
const OUTCOME_COPY: Record<DocumentSignatureReturnOutcome, { heading: string; detail: string | null }> = {
  done: {
    heading: 'Thank you. Your signature has been received.',
    // No "a copy is sent" line: nothing in this repo or the invite contract confirms the provider sends one.
    detail: null,
  },
  declined: {
    heading: 'You declined to sign. No signature was recorded.',
    detail: 'If this was a mistake, contact the sender of the proposal.',
  },
  closed: {
    heading: 'You left the signing page without finishing. The proposal is not signed yet.',
    detail: 'Use the link in your email to continue while it is valid.',
  },
};

export interface DocumentSignatureReturnAppProps {
  outcome: DocumentSignatureReturnOutcome;
}

export function DocumentSignatureReturnApp({ outcome }: DocumentSignatureReturnAppProps) {
  const { heading, detail } = OUTCOME_COPY[outcome];
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-4 text-text">
      <div className="w-full max-w-md space-y-3 text-center">
        <Text variant="headline-sm" as="h1">
          {heading}
        </Text>
        {detail && (
          <Text variant="body-md" color="muted">
            {detail}
          </Text>
        )}
      </div>
    </div>
  );
}
